<template>
  <div class="take-back-popup" :class="{ 'active': open }">
    <div class="popup__backdrop" @click="closePopup"></div>
    <div class="popup__box">
      <div class="close" @click="closePopup"><span class="fi-rr-cross"></span></div>
      Popup reprise mobile à venir
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'TakeBackPopup',
  computed: {
    ...mapState({
      open: state => state.takeBack.popup,
      loading: state => state.takeBack.loading
    })
  },
  methods: {
    ...mapActions('takeBack', ['closePopup']),
    selectStore (store) {
      const storeLink = document.querySelector('section.stores-popup .popup-store[data-code="' + store.code + '"] a')
      storeLink.click()
    },
    triggerGeolocation() {
      const geolocationLink = document.querySelector('header.main-header .head .actions .stores .store-selector .selector-map a.geolocation')
      if (geolocationLink) geolocationLink.click()
      this.closePopup()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/tools/*';
@import '../../../scss/mixins/*';


.take-back-popup{
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000000;
  height: 100vh;
  width: 100vw;

  &.active{
    display: block;
  }

  .popup__backdrop{
    background-color: rgba($black, 0.9);
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
  }

  .popup__box{
    max-width: 700px;
    background-color: $white;
    padding: 30px;
    position: absolute;
    top: 50%;
    left: 50%;
    @include transform(translateX(-50%) translateY(-50%) translateZ(0));
    @include radius(10px);

    @include responsive(mobile) {
      max-height: 100vh;
      width: calc(100vw - 40px);
    }

    .close {
      width: 40px;
      height: 40px;
      position: absolute;
      top: 10px;
      right: 10px;
      text-align: center;
      line-height: 42px;
      color: rgba($black, 0.7);
      cursor: pointer;
      padding-left: 1px;
      @include radius(100%);
      @include transition();

      &:hover {
        background-color: rgba($black, 0.2);
      }
    }
  }
}
</style>
